'use strict';

const _CONSTANTS = {
    markerAttribute: 'google-map-marker',
    locationAttribute: 'google-map-location',
    loadedEvent: 'initGoogleMap',
    storeCardSelector: '.store-locator-results .rolex-store-card.search-filters',
    storeFilterSelector: '.tab-btn.store-filter',
    storeUuidAttribute: 'store-address-uuid',
    storeRetailerAttribute: 'rolexRetailer',
    storeCertifiedPreOwnedAttribute: 'rolexCpo',
    storeServiceCentreAttribute: 'rolexService',
    storeStateAttribute: 'store-state-code',
    stateFilterSelector: '.country-link'
}
let currentStateFilter = null;
let clusterImageSrc = '';
let clusterImageSrcActive = '';
let clusterImageSrcBoutique = '';
let activeFilteredUUIDs = new Set();
const _STORE_FILTERS = {
    retailer: 'retailer',
    cpo: 'cpo',
    service: 'service'
}

const _MARKER_ICON_TYPE = {
    retailer: 'retailer',
    cpo: 'cpo',
    service: 'service'
}

const _MARKER_ICON_FILTER = {
    none: '',
    // Green -> gold shift while preserving white Rolex icon details.
    serviceGold: 'hue-rotate(276deg) saturate(1.45) brightness(1.08) contrast(1.02)',
    clusterGreen: '',  // original image is green — no filter needed
    clusterBlack: 'hue-rotate(235deg) saturate(0) brightness(0.65) contrast(3)',
    clusterGold: 'hue-rotate(276deg) saturate(1.45) brightness(1.08) contrast(1.02)'
}

let storeMarkerClusterer = null;
let storeFilterListenerBound = false;

function getStoreCard(uuid) {
    if (!uuid) {
        return null;
    }

    return document.querySelector(_CONSTANTS.storeCardSelector + '[' + _CONSTANTS.storeUuidAttribute + '="' + uuid + '"]');
}

function getStoreMarkerFilters(uuid) {
    const storeCard = getStoreCard(uuid);
    if (!storeCard) {
        return null;
    }
    return {
        retailer: storeCard.dataset[_CONSTANTS.storeRetailerAttribute] === 'true',
        cpo: storeCard.dataset[_CONSTANTS.storeCertifiedPreOwnedAttribute] === 'true',
        service: storeCard.dataset[_CONSTANTS.storeServiceCentreAttribute] === 'true',
        isRolexBoutique: storeCard.dataset.isRolexBoutique === 'true' ||  storeCard.getAttribute('data-is-rolex-boutique') === 'true'
    };
}

function hasStoreMarkerFilters(filters) {
    if (!filters) {
        return false;
    }

    return filters.retailer || filters.cpo || filters.service;
}

function shouldShowStoreMarker(markerData, filterType) {
    if (!markerData || !markerData.filters || !hasStoreMarkerFilters(markerData.filters)) {
        return false;
    }

    switch (filterType) {
        case _STORE_FILTERS.cpo:
            return markerData.filters.cpo;
        case _STORE_FILTERS.service:
            return markerData.filters.service;
        case _STORE_FILTERS.retailer:
        default:
            return markerData.filters.retailer;
    }
}

function resolveStoreMarkerType(filters) {
    if (!filters) {
        return _MARKER_ICON_TYPE.retailer;
    }

    if (filters.retailer) {
        return _MARKER_ICON_TYPE.retailer;
    }

    if (filters.cpo) {
        return _MARKER_ICON_TYPE.cpo;
    }

    if (filters.service) {
        return _MARKER_ICON_TYPE.service;
    }

    return _MARKER_ICON_TYPE.retailer;
}

function getMarkerAssets(content) {
    if (!content) {
        return null;
    }

    const images = content.querySelectorAll('img');

    if (!images || images.length < 2) {
        return null;
    }

    let primarySrc = images[0].getAttribute('src') || '';
    let activeSrc = images[1].getAttribute('src') || '';

    // Reset black image back to original before applying service gold
   // primarySrc = primarySrc.replace('pin.png', 'pin.png');
    //activeSrc = activeSrc.replace('pin-active.png', 'pin-active.png');

    return {
        defaultSrc: primarySrc,
        activeSrc: activeSrc
    };
}

function setMarkerIconByType(content, markerType, markerFilters) {
    if (!content) {
        return;
    }

    const images = content.querySelectorAll('img');
    if (!images || images.length < 2) {
        return;
    }

    const assets = getMarkerAssets(content);
    if (!assets || !assets.defaultSrc || !assets.activeSrc) {
        return;
    }

    // Remove any previous border class
    content.classList.remove('rolex-marker-boutique', 'rolex-marker-nonboutique');

    images.forEach(img => {
        img.style.filter = _MARKER_ICON_FILTER.none;
    });

    switch (markerType) {
        case _MARKER_ICON_TYPE.cpo:
            if (markerFilters && markerFilters.isRolexBoutique) {
                images[0].setAttribute('src', clusterImageSrcBoutique);
                content.classList.add('rolex-marker-boutique');
            } else {
                images[0].setAttribute('src', assets.defaultSrc);
                content.classList.add('rolex-marker-nonboutique');
            }
            images[1].setAttribute('src', assets.activeSrc);
            images.forEach(img => {
                img.style.filter = _MARKER_ICON_FILTER.clusterBlack;
            });
            break;
        case _MARKER_ICON_TYPE.service:
            //images[0].setAttribute('src', assets.defaultSrc);
            if (markerFilters && markerFilters.isRolexBoutique) {
                images[0].setAttribute('src', clusterImageSrcBoutique);
                content.classList.add('rolex-marker-boutique');
            } else {
                images[0].setAttribute('src', assets.defaultSrc);
                content.classList.add('rolex-marker-nonboutique');
            }
            images[1].setAttribute('src', assets.activeSrc);
            images.forEach(img => {
                img.style.filter = _MARKER_ICON_FILTER.serviceGold;
            });
            break;
        case _MARKER_ICON_TYPE.retailer:
        default:
            // Add border class for retailer
            if (markerFilters && markerFilters.isRolexBoutique) {
                images[0].setAttribute('src', clusterImageSrcBoutique);
                content.classList.add('rolex-marker-boutique');
            } else {
                images[0].setAttribute('src', assets.defaultSrc);
                content.classList.add('rolex-marker-nonboutique');
            }
            images[1].setAttribute('src', assets.activeSrc);
            images.forEach(img => {
                img.style.filter = _MARKER_ICON_FILTER.none;
            });
            break;
    }
}

function clearStoreMarkerClusterer() {
    if (!storeMarkerClusterer) {
        return;
    }

    if (typeof storeMarkerClusterer.clearMarkers === 'function') {
        storeMarkerClusterer.clearMarkers();
    }

    if (typeof storeMarkerClusterer.setMap === 'function') {
        storeMarkerClusterer.setMap(null);
    }

    storeMarkerClusterer = null;
}

function updateStoreMarkerClusterer(map, markers, components) {
    clearStoreMarkerClusterer();

    if (!markers || !markers.length) {
        return;
    }

    storeMarkerClusterer = addClusterMarkers(map, markers, components);
}

function applyStoreMarkerFilter(filterType, map, components, stateCode) {
    window.currentStoreFilter = filterType;

    if (stateCode !== undefined) {
        currentStateFilter = stateCode;
    }

    if (!map || !components || !window.storeMarkers) {
        return;
    }

    const filteredMarkers = [];
    const filteredPositions = [];
    activeFilteredUUIDs = new Set();  // <-- reset on every filter change

    Object.keys(window.storeMarkers).forEach(uuid => {
        const markerData = window.storeMarkers[uuid];

        if (!markerData || !markerData.marker) {
            return;
        }

        const matchesType = shouldShowStoreMarker(markerData, filterType);
        const matchesState = !currentStateFilter ||
            getStoreStateCode(uuid) === currentStateFilter;

        const shouldShow = matchesType && matchesState;

        if (shouldShow) {
            activeFilteredUUIDs.add(uuid);  // <-- track active UUIDs
        }

        if (shouldShow && markerData.content) {
            setMarkerIconByType(markerData.content, filterType, markerData.filters);
        }

        if (typeof markerData.marker.setMap === 'function') {
            markerData.marker.setMap(shouldShow ? map : null);
        } else {
            markerData.marker.map = shouldShow ? map : null;
        }

        if (shouldShow) {
            filteredMarkers.push(markerData.marker);
            filteredPositions.push(markerData.position);
        }
    });

    updateStoreMarkerClusterer(map, filteredMarkers, components);
    fitMapBoundsToPositions(map, filteredPositions);
    applyStoreListFilter(currentStateFilter, filterType);
}

function getStoreStateCode(uuid) {
    const storeCard = getStoreCard(uuid);
    if (!storeCard) return null;

    const stateCode = storeCard.dataset.storeStateCode || null;
    console.log('UUID:', uuid, '| stateCode:', stateCode); // <-- check console
    return stateCode;
}
function applyStoreListFilter(stateCode, filterType) {
    const storeCards = document.querySelectorAll(_CONSTANTS.storeCardSelector);

    storeCards.forEach(function(card) {
        const cardStateCode = card.dataset.storeStateCode;

        // State check — null means all states
        const matchesState = !stateCode || cardStateCode === stateCode;

        // Type check
        let matchesType = false;
        if (filterType === _STORE_FILTERS.cpo) {
            matchesType = card.dataset.rolexCpo === 'true';
        } else if (filterType === _STORE_FILTERS.service) {
            matchesType = card.dataset.rolexService === 'true';
        } else {
            // default retailer
            matchesType = card.dataset.rolexRetailer === 'true';
        }

        // AND logic — both must match
        card.style.display = (matchesState && matchesType) ? '' : 'none';
    });
}

function bindStateFilter(map, components) {
    document.addEventListener('click', function(event) {
        const stateLink = event.target.closest(_CONSTANTS.stateFilterSelector);
        if (!stateLink) return;

        event.preventDefault();

        // Active class on clicked state
        document.querySelectorAll(_CONSTANTS.stateFilterSelector)
            .forEach(link => link.classList.remove('active'));
        stateLink.classList.add('active');

        const selectedState = stateLink.dataset.stateCode || null;

        // AND with current type filter
        applyStoreMarkerFilter(
            window.currentStoreFilter || _STORE_FILTERS.retailer,
            map,
            components,
            selectedState
        );
    });
}

function bindStoreMarkerFilters(map, components) {
    if (storeFilterListenerBound || !map || !components) {
        return;
    }

    storeFilterListenerBound = true;

    document.addEventListener('click', function (event) {
        const button = event.target.closest(_CONSTANTS.storeFilterSelector);
        if (!button) return;

        // Active class on clicked tab
        document.querySelectorAll(_CONSTANTS.storeFilterSelector)
            .forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        const filterType = button.dataset.filter || _STORE_FILTERS.retailer;

        // AND with current state
        applyStoreMarkerFilter(filterType, map, components, currentStateFilter);
    });
}
function initMapControls(map, components) {
    if (!map || !components) {
        return;
    }

    const zoomIn = components.controlZoomIn;
    const zoomOut = components.controlZoomOut;

    if (zoomIn) {
        zoomIn.addEventListener('click', () => {
            map.setZoom(map.getZoom() + 1);
        })
    }

    if (zoomOut) {
        zoomOut.addEventListener('click', () => {
            const zoomOutIndex = map.getZoom();
            if (zoomOutIndex - 1 < 5) {
                return;
            }
            map.setZoom(zoomOutIndex - 1);
        })
    }
}

function getDefinedMarkers(components) {
    const { pointerMarker, clusterMarker } = components;

    const markers = {};
    if (pointerMarker) {
        markers.pointer = (uuid) => {
            const marker = document.createElement('div');
            marker.setAttribute(_CONSTANTS.markerAttribute, 'pointer');
            marker.setAttribute(_CONSTANTS.addressMarkerUUID, uuid);
            marker.innerHTML = pointerMarker.innerHTML;
            return marker;
        }
    }

    if (clusterMarker) {
        markers.cluster = (() => {
            const marker = document.createElement('div');
            marker.setAttribute(_CONSTANTS.markerAttribute, 'cluster');
            marker.innerHTML = clusterMarker.innerHTML;
            return marker;
        })
    }

    return markers;
}

function addLocationMarkers(components, positions, map) {
    const markerSet = getDefinedMarkers(components);
    const { AdvancedMarkerElement } = google.maps.marker;
    window.storeMarkers = {};
    const markers = positions.map(position => {
        const markerObject = {
            position
        }

        markerObject.content = markerSet.pointer(position.uuid);
        const markerFilters = getStoreMarkerFilters(position.uuid);
        const markerType = resolveStoreMarkerType(markerFilters);
        setMarkerIconByType(markerObject.content, markerType, markerFilters);
        const marker = new AdvancedMarkerElement(markerObject);

        window.storeMarkers[position.uuid] = {
            marker,
            position,
            map,
            components,
            content: markerObject.content,
            filters: markerFilters
        };

        marker.addListener("gmp-click", () => {
            map.panTo(marker.position);
            if (position.uuid) {
                components.container.dispatchEvent(new CustomEvent('select', {
                    detail: {
                        uuid: position.uuid
                    },
                }));
            }
        });

        return marker;
    });

    return markers;
}

function addClusterMarkers(map, markers, components) {
    const GoogleMarkerCluster = require('@googlemaps/markerclusterer');
    const { AdvancedMarkerElement } = google.maps.marker;
 
    const renderer = {
        render: (cluster, clusterStats, map) => {
            const counter = cluster.markers.length;
 
            // Pick color filter based on current filter type
            let colorFilter = _MARKER_ICON_FILTER.clusterGreen;  // default retailer
            let clusterClass = 'rolex-cluster-retailer';
 
            if (window.currentStoreFilter === _STORE_FILTERS.service) {
                colorFilter = _MARKER_ICON_FILTER.clusterGold;
                clusterClass = 'rolex-cluster-service';
            } else if (window.currentStoreFilter === _STORE_FILTERS.cpo) {
                colorFilter = _MARKER_ICON_FILTER.clusterBlack;
                clusterClass = 'rolex-cluster-cpo';
            }
 
            const content = document.createElement('div');
            content.className = `rolex-cluster ${clusterClass}`;
 
            content.innerHTML = `
                <div class="rolex-cluster-inner">
                    <img
                        src="${clusterImageSrc}"
                        alt="cluster"
                        class="rolex-cluster-img"
                        style="filter: ${colorFilter}"
                    />
                    <img
                        src="${clusterImageSrcActive}"
                        alt="cluster active"
                        class="rolex-cluster-img-active"
                        style="filter: ${colorFilter}"
                    />
                    <span class="rolex-cluster-count">${counter}</span>
                </div>
            `;
 
            const marker = new AdvancedMarkerElement({
                content,
                map,
                position: cluster._position
            });
 
            return marker;
        }
    };
 
    const cluster = new GoogleMarkerCluster.MarkerClusterer({ map, markers, renderer });
    return cluster;
}

function showMarker(map, options) {
    if (!map || !options) {
        return;
    }

    const { components, positions } = options;
    if (!components || !positions) {
        return;
    }

    const markerObject = {
        position: positions,
        map
    }

    const markerSet = getDefinedMarkers(components);
    markerObject.content = markerSet.pointer('store');

    const { AdvancedMarkerElement } = google.maps.marker;
    new AdvancedMarkerElement(markerObject);
}

function filterStoreListByVisibleMapMarkers(map) {
    if (!map || !window.storeMarkers) {
        return;
    }

    const bounds = map.getBounds();
    if (!bounds) {
        return;
    }

    Object.keys(window.storeMarkers).forEach(uuid => {
        const markerData = window.storeMarkers[uuid];
        const storeCard = getStoreCard(uuid);

        if (!markerData || !markerData.position || !storeCard) {
            return;
        }

        // If not in active filtered set — keep hidden, skip bounds check
        if (!activeFilteredUUIDs.has(uuid)) {
            storeCard.style.display = 'none';
            return;
        }

        const latLng = new google.maps.LatLng(
            markerData.position.lat,
            markerData.position.lng
        );

        // Inside bounds check — works for both clustered and individual markers
        const isInsideBounds = bounds.contains(latLng);

        storeCard.style.display = isInsideBounds ? '' : 'none';
    });
}

const _MAX_SINGLE_STORE_ZOOM = 12;

function fitMapBoundsToPositions(map, positions) {
    if (!map || !positions || !positions.length) {
        return;
    }

    const bounds = new google.maps.LatLngBounds();
    positions.forEach(function (position) {
        if (position && typeof position.lat === 'number' && typeof position.lng === 'number') {
            bounds.extend(new google.maps.LatLng(position.lat, position.lng));
        }
    });

    if (bounds.isEmpty()) {
        return;
    }

    map.fitBounds(bounds);

    // fitBounds() on a zero-area (single point) or very small bounds zooms all the
    // way in, hiding nearby stores. Cap the zoom once the bounds have been applied.
    google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
        if (map.getZoom() > _MAX_SINGLE_STORE_ZOOM) {
            map.setZoom(_MAX_SINGLE_STORE_ZOOM);
        }
    });
}

function bindMapBoundsFilter(map) {
    if (!map) {
        return;
    }

    google.maps.event.addListener(map, 'idle', function () {
        filterStoreListByVisibleMapMarkers(map);
    });
}

function createCustomMarker(map, options) {
    if (!map || !options) {
        return;
    }

    const { components, positions } = options;
    if (!components || !positions || !positions.length || !Array.isArray(positions)) {
        return;
    }

    const { googleMap } = components;

    if (!map || !googleMap) {
        return;
    }
    clusterImageSrc = googleMap.dataset.clusterImage || '';
    clusterImageSrcActive = googleMap.dataset.clusterImageActive || '';
    clusterImageSrcBoutique = googleMap.dataset.clusterImageBoutique || '';
    const markers = addLocationMarkers(components, positions, map);
    updateStoreMarkerClusterer(map, markers, components);
    bindStoreMarkerFilters(map, components);
    bindStateFilter(map, components);
    bindMapBoundsFilter(map);
    applyStoreMarkerFilter(_STORE_FILTERS.retailer, map, components, null);
    setTimeout(function () {
        filterStoreListByVisibleMapMarkers(map);
    }, 100);
}

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

function initMap(settings) {

    const { container, initialLocation, googleMapID, zoomFactor, options = {} } = settings

    if (!container) {
        return;
    }

    const googleMapOptions = {
        center: initialLocation,
        zoom: zoomFactor,
        mapTypeControl: false,
        disableDefaultUI: true,
        mapId: googleMapID,
        ...options
    }

    const map = new google.maps.Map(container, googleMapOptions);
    return map;
}

function initGoogleMapsApiUrl(googleApiKey, container) {
    if (!googleApiKey || !container) {
        return;
    }

    if (!window.initGoogleMap) {
        window.initGoogleMap = function () {
            document.dispatchEvent(new CustomEvent(_CONSTANTS.loadedEvent));
        }
    }

    const url = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey.value}&libraries=marker&callback=initGoogleMap&v=beta&solution_channel=GMP_CCS_customcontrols_v1`;

    const srcTags = document.head.querySelectorAll('script');
    if (srcTags) {
        let found = false;
        srcTags.forEach(srcTag => {
            found = srcTag.src === url
        });

        if (found) {
            window.initGoogleMap();
            return;
        }
    }

    if (window.google && window.google.maps && window.google.maps.marker) {
        window.initGoogleMap();
        return;
    }

    const scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.setAttribute('defer', '');
    scriptTag.setAttribute('async', '');
    scriptTag.setAttribute('type', 'text/javascript');

    document.head.append(scriptTag);
}

function getLocations(locations) {
    if (!locations) {
        return;
    }
    const seenUUIDs = new Set();
    const set = [];
    locations.forEach(location => {
        const data = location.attributes[_CONSTANTS.locationAttribute];
        if (!data || !data.value) {
            return;
        }
        try {
            const parsed = JSON.parse(data.value);
            if (!parsed) {
                return;
            }
            if (parsed.uuid) {
                if (seenUUIDs.has(parsed.uuid)) {
                    return;
                }
                seenUUIDs.add(parsed.uuid);
            }

            set.push(parsed);
        } catch (err) {}
    })
    return set;
}

document.addEventListener('click', function (e) {

    const storeCard = e.target.closest('.store-locator-results .rolex-store-card .holder .info .card-address-header');

    if (!storeCard) {
        return;
    }
    const parentCard = storeCard.closest('.store-locator-results .rolex-store-card');

    const uuid = parentCard.getAttribute('store-address-uuid');

    if (!uuid || !window.storeMarkers) {
        return;
    }

    const markerData = window.storeMarkers[uuid];

    if (!markerData) {
        return;
    }

    var marker = markerData.marker,
    position = markerData.position,
    map = markerData.map,
    components = markerData.components;
    map.panTo(marker.position);
    map.setZoom(12);
    const viewItem = e.target.closest('[store-locator-view]');
    if (!viewItem) {
        return;
    }
    document.querySelectorAll('[store-locator-view]')
        .forEach(item => {
            item.removeAttribute('store-locator-view-selected');
        });
    viewItem.setAttribute('store-locator-view-selected', '');
    if (position.uuid) {
        components.container.dispatchEvent(
            new CustomEvent('select', {
                detail: {
                    uuid: position.uuid
                }
            })
        );
    }
});
module.exports = {
    uuidv4,
    initMap,
    initGoogleMapsApiUrl,
    createCustomMarker,
    initMapControls,
    getLocations,
    showMarker
}